import React from 'react';
import { useNavigate } from 'react-router-dom';
import MenuItems from './MenuItems';

export const MenuItemsWrapper = ({ menu, section, navigation, resetMenu }) => {
	const navigate = useNavigate();

	function navigateToPath(path) {
		navigate(path);
	}
	return (
		<MenuItems
			section={section}
			navigation={navigation}
			menu={menu}
			navigate={navigateToPath}
			resetMenu={resetMenu}
		/>
	);
};
